// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const gravelPile = defineModel({
  id: "gravel-pile",
  batchId: "future",
  name: "Gravel pile",
  tags: ["scenery","gravel","pile","low-poly","age-of-mcp","future"],
  summary: "Crushed gravel — road beds, concrete and drainage.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.42,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.4, 0.42, 0.04, 12), color: "#7f7a70", position: [0, 0.02, 0] },
      { geometry: new THREE.ConeGeometry(0.34, 0.26, 8), color: "#8f8a80", position: [0, 0.16, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#7f7a70", position: [0.1, 0.14, 0.06] },
      { geometry: new THREE.IcosahedronGeometry(0.045, 0), color: "#9d988e", position: [-0.12, 0.1, -0.04], rotation: [0.4, 0.7, 0.3] },
      { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#7f7a70", position: [0, 0.2, -0.08], rotation: [0.8, 1.4, 0.6] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#9d988e", position: [0.18, 0.05, 0.14], rotation: [1.2, 2.1, 0.9] },
      { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#7f7a70", position: [-0.2, 0.04, 0.1], rotation: [1.6, 2.8, 1.2] },
      { geometry: new THREE.IcosahedronGeometry(0.045, 0), color: "#9d988e", position: [0.24, 0.04, -0.12], rotation: [2, 3.5, 1.5] },
      { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#7f7a70", position: [-0.06, 0.16, 0.12], rotation: [2.4, 4.2, 1.8] },
    ],
  animations: [],
});
